const TEST_CONTAINER = 'https://www.google.com/';

export default {
    TEST_CONTAINER,
};
